import { LogUser } from './logger.types';

const SESSION_STORAGE_KEY = '__activity_logger_session_id__';

let cachedSessionId: string | null = null;
let cachedUser: LogUser | null = null;

function generateUuid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `s-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

export function getSessionId(): string {
  if (cachedSessionId) return cachedSessionId;
  try {
    const existing = window.sessionStorage.getItem(SESSION_STORAGE_KEY);
    if (existing) { cachedSessionId = existing; return existing; }
    const fresh = generateUuid();
    window.sessionStorage.setItem(SESSION_STORAGE_KEY, fresh);
    cachedSessionId = fresh;
    return fresh;
  } catch {
    const fallback = generateUuid();
    cachedSessionId = fallback;
    return fallback;
  }
}

export function setUser(user: LogUser): void { cachedUser = user; }
export function clearUser(): void { cachedUser = null; }
export function getUser(): LogUser | null { return cachedUser; }
